'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Info = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconsComponents = require('../../icons-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Info = exports.Info = function Info(_ref) {
  var message = _ref.message;
  return _react2.default.createElement(
    'div',
    { className: 'qd-info-message' },
    _react2.default.createElement(_iconsComponents.InfoIcon, null),
    _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: message } })
  );
};